const buildEmptyApplicant = () => {
  return {
    title: "",
    given_name: "",
    middle_name: "",
    family_name: "",
    home_phone: "",
    mobile: "",
    work_phone: "",
    email: "",
    dob: {
      day: "",
      month: "",
      year: "",
    },
    licence_expiry: {
      day: "",
      month: "",
      year: "",
    },
    gender: "",
    martial_status: "",
    maiden_name: "",
    resident_status: "",
    dependant_children: "",
  };
};

const ensureApplicantShape = (applicant = {}) => {
  const nextApplicant = {
    ...buildEmptyApplicant(),
    ...applicant,
  };

  nextApplicant.dob = {
    day: "",
    month: "",
    year: "",
    ...(applicant.dob || {}),
  };

  nextApplicant.licence_expiry = {
    day: "",
    month: "",
    year: "",
    ...(applicant.licence_expiry || {}),
  };

  return nextApplicant;
};

const getLegacyApplicantKeys = (rawSection) => {
  return Object.keys(rawSection || {})
    .filter((key) => /^applicant\d+$/i.test(key))
    .sort((left, right) => {
      const leftNumber = Number(left.replace("applicant", ""));
      const rightNumber = Number(right.replace("applicant", ""));
      return leftNumber - rightNumber;
    });
};

export const normalizeGeneralDetails = (rawSection = {}) => {
  const normalized = {
    applicants: {},
    applicant_order: [],
  };

  if (rawSection && rawSection.applicants && Object.keys(rawSection.applicants).length > 0) {
    const applicantOrder = Array.isArray(rawSection.applicant_order)
      ? rawSection.applicant_order.filter((id) => rawSection.applicants[id] !== undefined)
      : Object.keys(rawSection.applicants);

    applicantOrder.forEach((id) => {
      normalized.applicants[id] = ensureApplicantShape(rawSection.applicants[id]);
    });
    normalized.applicant_order = applicantOrder;
  } else {
    const legacyApplicantKeys = getLegacyApplicantKeys(rawSection);
    legacyApplicantKeys.forEach((key) => {
      normalized.applicants[key] = ensureApplicantShape(rawSection[key]);
      normalized.applicant_order.push(key);
    });
  }

  if (normalized.applicant_order.length === 0) {
    normalized.applicant_order = ["applicant1"];
    normalized.applicants.applicant1 = buildEmptyApplicant();
  }

  return normalized;
};

export const buildPersistedGeneralDetails = (normalizedSection) => {
  const persisted = {
    applicants: {},
    applicant_order: [...(normalizedSection.applicant_order || [])],
  };

  (normalizedSection.applicant_order || []).forEach((id, index) => {
    const applicantData = ensureApplicantShape(normalizedSection.applicants[id]);
    persisted.applicants[id] = applicantData;
    persisted[`applicant${index + 1}`] = applicantData;
  });

  if (!persisted.applicant1) {
    persisted.applicant1 = buildEmptyApplicant();
  }

  return persisted;
};

export const createApplicantId = (existingIds = []) => {
  let nextNumber = existingIds.length + 1;
  let id = `applicant${nextNumber}`;
  while (existingIds.includes(id)) {
    nextNumber += 1;
    id = `applicant${nextNumber}`;
  }
  return id;
};

